<template>
  <div class="rank-container" :class="{ 'portrait-mode': mode === 'portrait' }">
    <!-- Top 1 Container -->
    <div class="top1-container">
      <img src="@/assets/leaderboard/rank-top-bg.png" alt="第一名背景" class="top1-bg" />
      <div class="title-wrapper">
        <div class="title">日榜开单王 业绩排序</div>
        <div class="date-picker-wrapper">
          <el-date-picker
            v-model="selectedDate"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            size="mini"
            @change="handleDateChange"
            :clearable="false"
            :prefix-icon="''"
            :append-to-body="false"
            :popper-class="'date-picker-popper'"
          />
        </div>
      </div>
      <div class="avatar-wrapper">
        <img src="@/assets/leaderboard/rank-1.png" alt="第一名头像" class="avatar-img" />
      </div>
      <div class="top-text gradient-text">TOP1</div>
      <div class="team-wrapper">
        <div class="team-name gradient-text">{{ topPerformer ? `${topPerformer.team} - ${topPerformer.name}` : '-' }}</div>
        <div class="performance">
          <span class="number gradient-text">{{ topPerformer ? topPerformer.performance : '0' }}</span>
          <span class="unit">万</span>
        </div>
      </div>
    </div>

    <!-- Ranking Card -->
    <div class="ranking-card" @wheel="handleRankWheel">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- Table Header -->
      <div class="table-header">
        <div class="header-cell rank-col">排名</div>
        <div class="header-cell name-col">姓名</div>
        <div class="header-cell team-col">所属队伍</div>
        <div class="header-cell performance-col">销售业绩</div>
      </div>

      <!-- Table Body - Landscape Mode with Three Sections -->
      <div class="table-body-landscape" v-if="mode === 'landscape'">
        <!-- 前三名 -->
        <div class="top-section">
          <div
            v-for="(item, index) in topThreeData"
            :key="`top-${index}`"
            class="table-row top-three"
          >
            <div class="table-cell rank-col">
              <div class="rank-icon" :style="{ backgroundImage: `url(${require('@/assets/leaderboard/rank-bg.png')})` }">
                {{ item.rank }}
              </div>
            </div>
            <div class="table-cell name-col">{{ item.name }}</div>
            <div class="table-cell team-col">{{ item.team }}</div>
            <div class="table-cell performance-col">{{ formatCurrency(item.performance, true) }}</div>
          </div>
        </div>

        <!-- 中间滚动区域 -->
        <div class="middle-section" v-if="middleData.length > 0">
          <vue-seamless-scroll :data="middleData" :class-option="classOption" class="seamless-warp">
            <div
              v-for="(item, index) in middleData"
              :key="`${index}-${item.rank}-${item.name}`"
              class="table-row"
            >
              <div class="table-cell rank-col">{{ item.rank }}</div>
              <div class="table-cell name-col">{{ item.name }}</div>
              <div class="table-cell team-col">{{ item.team }}</div>
              <div class="table-cell performance-col">{{ formatCurrency(item.performance, true) }}</div>
            </div>
          </vue-seamless-scroll>
        </div>

        <!-- 后三名 -->
        <div class="bottom-section" v-if="bottomThreeData.length > 0">
          <div
            v-for="(item, index) in bottomThreeData"
            :key="`bottom-${index}`"
            class="table-row bottom-three"
          >
            <div class="table-cell rank-col">{{ item.rank }}</div>
            <div class="table-cell name-col">{{ item.name }}</div>
            <div class="table-cell team-col">{{ item.team }}</div>
            <div class="table-cell performance-col">{{ formatCurrency(item.performance, true) }}</div>
          </div>
        </div>
      </div>

      <!-- Portrait Mode Table Body with Three Sections -->
      <div class="table-body-portrait" v-else>
        <!-- 前三名 -->
        <div class="top-section">
          <div
            v-for="(item, index) in topThreeData"
            :key="`top-${index}`"
            class="table-row top-three"
          >
            <div class="table-cell rank-col">
              <div class="rank-icon" :style="{ backgroundImage: `url(${require('@/assets/leaderboard/rank-bg.png')})` }">
                {{ item.rank }}
              </div>
            </div>
            <div class="table-cell name-col">{{ item.name }}</div>
            <div class="table-cell team-col">{{ item.team }}</div>
            <div class="table-cell performance-col">{{ formatCurrency(item.performance, true) }}</div>
          </div>
        </div>

        <!-- 中间滚动区域 -->
        <div class="middle-section" v-if="middleData.length > 0">
          <vue-seamless-scroll :data="middleData" :class-option="classOption" class="seamless-warp">
            <div
              v-for="(item, index) in middleData"
              :key="`${index}-${item.rank}-${item.name}`"
              class="table-row"
            >
              <div class="table-cell rank-col">{{ item.rank }}</div>
              <div class="table-cell name-col">{{ item.name }}</div>
              <div class="table-cell team-col">{{ item.team }}</div>
              <div class="table-cell performance-col">{{ formatCurrency(item.performance, true) }}</div>
            </div>
          </vue-seamless-scroll>
        </div>

        <!-- 后三名 -->
        <div class="bottom-section" v-if="bottomThreeData.length > 0">
          <div
            v-for="(item, index) in bottomThreeData"
            :key="`bottom-${index}`"
            class="table-row bottom-three"
          >
            <div class="table-cell rank-col">{{ item.rank }}</div>
            <div class="table-cell name-col">{{ item.name }}</div>
            <div class="table-cell team-col">{{ item.team }}</div>
            <div class="table-cell performance-col">{{ formatCurrency(item.performance, true) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { request } from 'beans-admin-plugin'
import vueSeamlessScroll from 'vue-seamless-scroll'

@Component({
  components: {
    vueSeamlessScroll
  }
})
export default class RankCard extends Vue {
  @Prop({ default: 'landscape' }) mode // 'landscape' | 'portrait'

  dailyData = {
    daily_individual: {
      date: '',
      rankings: []
    }
  }

  selectedDate = new Date().toISOString().split('T')[0] // 默认今天
  loading = false // loading状态

  // 日期选择器配置
  pickerOptions = {
    disabledDate(time) {
      // 禁用未来日期
      return time.getTime() > Date.now()
    }
  }

  // 处理排行榜区域的滚轮事件，阻止事件冒泡到父组件
  handleRankWheel(event) {
    // 让事件在此处停止传播，避免触发父组件的滚轮切换
    event.stopPropagation()
  }

  async fetchDaily(date = null) {
    try {
      this.loading = true
      const targetDate = date || this.selectedDate
      const data = await request.get('leaderboard/daily_individual', {
        params: { date: targetDate }
      })
      this.dailyData = data
    } catch (error) {
      console.error('Failed to fetch daily individual data:', error)
    } finally {
      this.loading = false
    }
  }

  // 处理日期变化
  handleDateChange(date) {
    if (date) {
      this.fetchDaily(date)
    }
  }

  // vue-seamless-scroll 配置
  get classOption() {
    return {
      step: 0.5,            // 滚动速度，数值越大速度越快
      limitMoveNum: 3,    // 开始无缝滚动的数据量
      hoverStop: true,    // 鼠标悬停停止滚动
      direction: 1,       // 0向下 1向上 2向左 3向右
      openWatch: true,    // 开启数据实时监控刷新dom
      singleHeight: 0,    // 单步运动停止的高度(0为无缝滚动)
      waitTime: 1000      // 单步运动停止的时间
    }
  }

  mounted() {
    this.fetchDaily()
  }

  get dailyIndividualData() {
    const data = this.dailyData.daily_individual.rankings || []

    // 计算排名并排序
    const sortedData = [...data]
      .sort((a, b) => {
        const actualA = parseFloat(a.order_actual) || 0
        const actualB = parseFloat(b.order_actual) || 0
        if (actualB !== actualA) {
          return actualB - actualA // 按业绩降序
        }
        return a.id - b.id // 业绩相同按id升序
      })

    // 计算排名（支持并列）
    const rankedData = []
    let currentRank = 1

    for (let i = 0; i < sortedData.length; i++) {
      const item = sortedData[i]
      const prevItem = sortedData[i - 1]

      // 如果当前项的业绩与前一项不同，更新排名
      if (i > 0 && parseFloat(item.order_actual) !== parseFloat(prevItem.order_actual)) {
        currentRank = i + 1
      }

      rankedData.push({
        rank: currentRank,
        name: item.name,
        team: item.team_name || '-', // 使用team_name字段
        performance: item.order_actual,
      })
    }

    return rankedData
  }

  get topPerformer() {
    const firstRanked = this.dailyIndividualData[0]
    if (!firstRanked) return null

    return {
      name: firstRanked.name,
      team: firstRanked.team,
      performance: this.formatCurrency(firstRanked.performance, false)
    }
  }

  // 竖屏模式数据分组
  get topThreeData() {
    return this.dailyIndividualData.slice(0, 3)
  }

  get middleData() {
    const data = this.dailyIndividualData
    if (data.length <= 6) return []
    return data.slice(3, -3)
  }

  get bottomThreeData() {
    const data = this.dailyIndividualData
    if (data.length <= 6) return []
    return data.slice(-3)
  }


  formatCurrency(amount, unit) {
    const num = parseFloat(amount) || 0
    if (num === 0) return '0'

    // 转换为万为单位
    const wanAmount = num / 10000
    return `${wanAmount.toLocaleString()}${unit ? '万' : ''}`;
  }
}
</script>

<style lang="scss" scoped>
.gradient-text {
  background: linear-gradient(90deg, #ffe3a8 0%, #fffefd 50%, #ffe3a8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.rank-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  min-height: 0; // 允许flex子元素缩小
  overflow: visible; // 确保弹出层可见
}

.top1-container {
  position: relative;
  flex-shrink: 0; // 确保TOP1区域不会被压缩
  overflow: visible; // 确保日期选择器弹出层可见

  .top1-bg {
    width: 100%;
    height: auto;
    display: block;
  }

  .title-wrapper {
    position: absolute;
    top: 14.2%;
    left: 7.9%;
    right: 7.9%;
    display: flex;
    align-items: center;

    .title {
      color: #4d2b07;
      font-size: 1.8vh; // 从2.2vh缩小到1.8vh
      font-weight: 800;
      white-space: nowrap;
      flex-shrink: 0; // 防止标题被压缩
    }

    .date-picker-wrapper {
      margin-left: 1vh; // 减少左边距
      flex-shrink: 1; // 允许日期选择器被压缩
      position: relative; // 为z-index提供定位上下文
      z-index: 100; // 确保弹出层在最上层

      ::v-deep .el-input__inner {
        border: 1px solid #fccb9a;
        border-radius: 0.4vh; // 稍微减少圆角
        height: 2.2vh; // 从2.8vh缩小到2.2vh
        line-height: 2.2vh;
        font-size: 1vh; // 从1.2vh缩小到1vh
        color: #4d2b07;
        background: rgba(255, 255, 255, 0.9);
        padding: 0 0.6vh; // 减少内边距

        &:focus {
          border-color: #8a5524;
        }
      }

      ::v-deep .el-input {
        width: 9vh; // 从12vh缩小到9vh
      }

      // 确保日期选择器弹出层有足够高的层级
      ::v-deep .el-picker-panel {
        z-index: 2000 !important;
      }

      // 自定义弹出层样式，确保在全屏模式下正确显示
      ::v-deep .date-picker-popper {
        z-index: 2000 !important;
        position: absolute !important;
      }

      ::v-deep .el-icon-date {
        display: none;
      }
    }
  }

  .avatar-wrapper {
    position: absolute;
    top: 43.6%;
    left: 8.6%;
    width: 18%;
    height: 48.2%;

    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .top-text {
    position: absolute;
    top: 52.1%;
    left: 29.8%;
    font-size: 2.8vh;
    font-weight: 700;
    @extend .gradient-text;
  }

  .team-wrapper {
    position: absolute;
    top: 48%;
    left: 57.1%;

    .team-name {
      font-size: 1.2vh;
      font-weight: 600;
      @extend .gradient-text;
    }

    .performance {
      display: flex;
      align-items: baseline;
      gap: 0.2vh;

      .number {
        font-size: 2.8vh;
        font-weight: 700;
        @extend .gradient-text;
      }

      .unit {
        font-size: 1.4vh;
        font-weight: 600;
        color: #ffe8b8;
      }
    }
  }
}

.ranking-card {
  flex: 1;
  background: white;
  border-radius: 1.5vh;
  border: 2px solid #fccb9a;
  padding: 1.5vh;
  box-shadow: 0 0.5vh 1.5vh rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 2vh;
  min-height: 0; // 允许flex子元素缩小

  .table-header {
    position: absolute;
    top: -1vh;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 3vh);
    display: flex;
    background: linear-gradient(90deg, #eab275 0%, #fefdfb 50%, #eab275 100%);
    border-radius: 2vh;
    padding: 0.15vh 2vh;
    box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.15);

    .header-cell {
      padding: 0.3vh 0.3vh;
      text-align: center;
      font-size: 1.4vh;
      font-weight: 600;
      color: #4d2b07;

      &.rank-col { flex: 0 0 15%; }
      &.name-col { flex: 0 0 20%; }
      &.team-col { flex: 1; }
      &.performance-col { flex: 0 0 25%; text-align: right; }
    }
  }

  .table-body {
    flex: 1;
    padding: 2vh 2vh 0;
    overflow-y: auto; // 添加垂直滚动
    min-height: 0; // 允许flex子元素缩小

    // 滚动条样式美化
    &::-webkit-scrollbar {
      width: 0.5vh;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 0.25vh;
    }

    &::-webkit-scrollbar-thumb {
      background: #fccb9a;
      border-radius: 0.25vh;

      &:hover {
        background: #eab275;
      }
    }

    .table-row {
      display: flex;
      align-items: flex-start;
      min-height: 3.2vh;
      padding: 0.6vh 0;

      .table-cell {
        padding: 0 0.3vh;
        text-align: center;
        font-size: 1.2vh;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #4a4a4a;

        &.rank-col {
          flex: 0 0 15%;
          padding: 0;
        }
        &.name-col {
          flex: 0 0 20%;
          min-width: 0;
          word-break: break-all;
          white-space: normal;
          line-height: 1.2;
        }
        &.team-col {
          flex: 1;
          word-break: break-all;
          white-space: normal;
          line-height: 1.2;
        }
        &.performance-col { flex: 0 0 25%; justify-content: flex-end; }
      }
    }
  }

  // 横屏模式三段式布局
  .table-body-landscape {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 2vh 2vh 0;
    min-height: 0;

    .top-section {
      flex-shrink: 0;
      margin-bottom: 1vh;
    }

    .middle-section {
      flex: 1;
      margin-bottom: 1vh;
      min-height: 0;
      overflow: hidden; // 隐藏溢出内容，实现轮播效果
      position: relative;

      .seamless-warp {
        height: 100%;
        overflow: hidden;
      }
    }

    .bottom-section {
      flex-shrink: 0;
    }

    .table-row {
      display: flex;
      align-items: flex-start;
      min-height: 3.2vh;
      padding: 0.6vh 0;

      &.top-three {
        font-weight: 700;
        align-items: center; // 确保整行垂直居中

        .table-cell {
          align-items: center; // 单元格内容垂直居中
          justify-content: center; // 单元格内容水平居中
          padding-top: 0; // 移除顶部padding，因为需要垂直居中

          &.name-col,
          &.team-col,
          &.performance-col {
            color: #e29d49 !important; // 前三名的姓名、队伍、业绩使用金黄色
          }

          &.performance-col {
            justify-content: flex-end; // 业绩列保持右对齐
          }
        }
      }

      &.bottom-three {
        font-weight: 700;
        color: #d32f2f !important; // 后三名所有文字都使用红色

        .table-cell {
          color: #d32f2f !important; // 确保所有单元格都是红色
        }
      }

      .table-cell {
        padding: 0 0.3vh;
        text-align: center;
        font-size: 1.2vh;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #4a4a4a;

        &.rank-col {
          flex: 0 0 15%;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .rank-icon {
            width: 3vh;
            height: 3vh;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.4vh;
            font-weight: 700;
            color: white !important; // 确保icon内的字体是白色
            text-shadow: 0 0.1vh 0.2vh rgba(0, 0, 0, 0.5);
          }
        }
        &.name-col {
          flex: 0 0 20%;
          min-width: 0;
          word-break: break-all;
          white-space: normal;
          line-height: 1.2;
        }
        &.team-col {
          flex: 1;
          word-break: break-all;
          white-space: normal;
          line-height: 1.2;
        }
        &.performance-col { flex: 0 0 25%; justify-content: flex-end; }
      }
    }
  }
}

// 竖屏模式样式调整 - 增大字体和间距以提高可读性
.rank-container.portrait-mode {
  width: 95%;
  gap: 2vh; // 增大间距

  .top1-container {
    .title-wrapper {
      .title {
        font-size: 2vh; // 适中的标题字体
        font-weight: 800;
      }

      .date-picker-wrapper {
        margin-left: 1.2vh; // 增大左边距
        z-index: 100; // 确保弹出层在最上层

        ::v-deep .el-input__inner {
          height: 2.5vh; // 适中的高度
          line-height: 2.5vh;
          font-size: 1.2vh; // 适中的字体
          padding: 0 0.6vh; // 适中的内边距
        }

        ::v-deep .el-input {
          width: 10vh; // 适中的宽度
        }

        // 确保日期选择器弹出层有足够高的层级
        ::v-deep .el-picker-panel {
          z-index: 2000 !important;
        }
      }
    }

    .top-text {
      font-size: 3.2vh; // 适中的TOP1字体
      font-weight: 800;
    }

    .team-wrapper {
      .team-name {
        font-size: 1.4vh; // 适中的团队名称字体
        font-weight: 700;
      }

      .performance {
        .number {
          font-size: 3vh; // 适中的数字字体
          font-weight: 800;
        }

        .unit {
          font-size: 1.6vh; // 适中的单位字体
        }
      }
    }
  }

  .ranking-card {
    margin-top: 2vh; // 增大上边距
    padding: 2vh; // 增大内边距
    border-radius: 2vh; // 增大圆角

    .table-header {
      top: -1.8vh;
      width: calc(100% - 3vh); // 调整宽度
      padding: 0 2vh; // 增大padding
      border-radius: 2.5vh; // 增大圆角

      .header-cell {
        padding: 0.6vh 0.5vh; // 适中的padding
        font-size: 1.6vh; // 适中的表头字体
        font-weight: 700;
      }
    }

    .table-body {
      padding: 3vh 2vh 0; // 增大padding
      overflow-y: auto; // 保持滚动功能

      .table-row {
        min-height: 3.5vh; // 适中的行高
        padding: 0.7vh 0; // 适中的padding

        .table-cell {
          padding: 0 0.5vh; // 增大padding
          font-size: 1.4vh; // 适中的单元格字体
          font-weight: 600;
        }
      }
    }

    // 竖屏模式三段式布局
    .table-body-portrait {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 1vh;
      min-height: 0;

      .top-section {
        flex-shrink: 0;
        margin-bottom: 1vh;
      }

      .middle-section {
        flex: 1;
        margin-bottom: 1vh;
        min-height: 0;
        overflow: hidden; // 隐藏溢出内容，实现轮播效果
        position: relative;

        .seamless-warp {
          height: 100%;
          overflow: hidden;
        }
      }

      .bottom-section {
        flex-shrink: 0;
      }

      .table-row {
        display: flex;
        align-items: flex-start;
        min-height: 3.5vh;
        padding: 0.7vh 0;

        &.top-three {
          font-weight: 700;
          align-items: center; // 确保整行垂直居中

          .table-cell {
            align-items: center; // 单元格内容垂直居中
            justify-content: center; // 单元格内容水平居中
            padding-top: 0; // 移除顶部padding，因为需要垂直居中

            &.name-col,
            &.team-col,
            &.performance-col {
              color: #e29d49 !important; // 前三名的姓名、队伍、业绩使用金黄色
            }

            &.performance-col {
              justify-content: flex-end; // 业绩列保持右对齐
            }
          }
        }

        &.bottom-three {
          font-weight: 700;
          color: #d32f2f !important; // 后三名所有文字都使用红色

          .table-cell {
            color: #d32f2f !important; // 确保所有单元格都是红色
          }
        }

        .table-cell {
          padding: 0 0.5vh;
          text-align: center;
          font-size: 1.4vh;
          font-weight: 600;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          color: #4a4a4a;
          padding-top: 0.2vh;

          &.rank-col {
            flex: 0 0 15%;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .rank-icon {
              width: 3.5vh;
              height: 3.5vh;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.6vh;
              font-weight: 700;
              color: white !important; // 确保icon内的字体是白色
              text-shadow: 0 0.1vh 0.2vh rgba(0, 0, 0, 0.5);
            }
          }
          &.name-col {
            flex: 0 0 20%;
            min-width: 0;
            word-break: break-all;
            white-space: normal;
            line-height: 1.2;
          }
          &.team-col {
            flex: 1;
            word-break: break-all;
            white-space: normal;
            line-height: 1.2;
          }
          &.performance-col { flex: 0 0 25%; justify-content: flex-end; }
        }
      }
    }
  }
}

// Loading 效果样式
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 1.5vh;
  z-index: 10;

  .loading-spinner {
    width: 4vh;
    height: 4vh;
    border: 0.3vh solid #f3f3f3;
    border-top: 0.3vh solid #fccb9a;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1vh;
  }

  .loading-text {
    color: #4d2b07;
    font-size: 1.4vh;
    font-weight: 600;
  }
}

// 竖屏模式下的 loading 样式调整
.rank-container.portrait-mode {
  .loading-overlay {
    border-radius: 2vh;

    .loading-spinner {
      width: 5vh;
      height: 5vh;
      border-width: 0.4vh;
      margin-bottom: 1.5vh;
    }

    .loading-text {
      font-size: 1.6vh;
    }
  }
}

// 旋转动画
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
